import { useEffect } from 'react';

import { useConsent } from 'src/utils/consent';
import { loadGtm } from 'src/utils/consentScripts';

/** Renders nothing; starts consent-gated third-party scripts once they are allowed. */
const ConsentScripts = () => {
  const { analytics } = useConsent();

  useEffect(() => {
    if (analytics) loadGtm();
  }, [analytics]);

  return null;
};

export default ConsentScripts;
